import * as yup from 'yup';

const extraMarketingSchema = yup.object().shape({
  name: yup.string().required('common.required'),
  type: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
  mainImageMedia: yup.object().shape({
    id: yup.string(),
    fileId: yup.string(),
  }).nullable().required('common.required'),
});

export default extraMarketingSchema;
